module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_ja-f5d1b3f7e2e8e3a53342c9750b1b6451.jpg";